import { ActionReducerMap } from '@ngrx/store';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';

export interface CoreState {
  router: RouterReducerState;
}

export const coreReducers: ActionReducerMap<CoreState> = {
  router: routerReducer,
};
